import { useState, useEffect } from 'react';

export function usePricing() {
  const [pricing, setPricing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const getPricingUrl = `https://us-central1-polletask-dev.cloudfunctions.net/billing-getPricingHttp`;

        const response = await fetch(getPricingUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const result = await response.json();

        if (result.success && result.pricing) {
          setPricing(result.pricing);
        } else {
          setError(result.error || 'Failed to fetch pricing');
        }
      } catch (err) {
        console.error('Error fetching pricing:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPricing();
  }, []);

  return { pricing, loading, error };
}

